import AgenciaObjetivoDashboardAdminPage from "./AgenciaObjetivoDashboardAdminPage";

export {AgenciaObjetivoDashboardAdminPage}
export default AgenciaObjetivoDashboardAdminPage
